import { apiClient } from './client';
import type { WelcomePage, UpdateWelcomeRequest } from '../types';

export const welcomeApi = {
  /**
   * Get current welcome page (all authenticated users)
   */
  async getCurrent(): Promise<WelcomePage> {
    return apiClient.get<WelcomePage>('/api/welcome/current');
  },

  /**
   * Update welcome page content (admin only)
   * Automatically increments version on the server
   */
  async update(data: UpdateWelcomeRequest): Promise<WelcomePage> {
    return apiClient.put<WelcomePage>('/api/welcome/admin', data);
  },
};
